export default {
  loading: {
    id: 'bo-seller.listings.loading',
    defaultMessage: 'Loading',
  },
  errorOnUpdate: {
    id: 'bo-seller.listings.errorOnUpdate',
    defaultMessage:
      'An error occurred while getting back the info for the listing',
  },
}
